module.exports = __webpack_public_path__ + "img/wait.d6872e77.png";